import { ELanguage } from "@microfrontends/react-components"

export function showLoginModal(langCode: ELanguage) {
    const loginEvent = new CustomEvent('LOGIN_POPUP', {
        detail: {
            langCode: langCode === ELanguage.VI ? 'vi' : 'en',
            isNeedReload: false
        }
    })
    window.dispatchEvent(loginEvent)
}
